import api from './api';

export interface PrescriptionLinkResponse {
  signaturerx_patient_id: string;
  created: boolean;
  url: string;
}

export interface PrescriptionItem {
  signaturerx_prescription_id?: string | null;
  date?: string | null;
  medication_name?: string | null;
  dosage_instruction?: string | null;
  quantity?: string | null;
  notes?: string | null;
  status?: string | null;
  url?: string | null;
  medicines_count?: number | null;
}

export interface PrescriptionListResponse {
  signaturerx_patient_id?: string | null;
  patient_url?: string | null;
  fetched_at: string;
  items: PrescriptionItem[];
}

export const signatureRxService = {
  /**
   * Ensures the patient exists in SignatureRx and returns the URL to open.
   * Idempotent — reuses the stored SignatureRx patient id when we already have one.
   */
  async getPrescribeLink(patientId: number): Promise<PrescriptionLinkResponse> {
    const response = await api.post(`/prescriptions/patients/${patientId}/prescribe-link`);
    return response.data;
  },

  async getPrescriptions(patientId: number): Promise<PrescriptionListResponse> {
    const response = await api.get(`/prescriptions/patients/${patientId}`);
    return response.data;
  },
};

export default signatureRxService;
